import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'checkbox',
    templateUrl: 'checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})

export class CheckboxComponent implements OnInit {
    @Input() public disabled = false;
    @Input() public checked = false;
    @Input() public text = '';
    @Input() public note = '';
    @Input() public value: any = '';

    @Output() public onChangeEmitter = new EventEmitter<any>();
    public constructor() { }

    public ngOnInit() { }

    public onChangeHandler(e: Event){
        const target = e.target as HTMLInputElement;
        this.onChangeEmitter.emit([this.value, target.checked]);
    }
}